import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { useAppStore } from '@globals/stores/app';

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.afterEach((to, from) => {
	const appStore = useAppStore();
	appStore.pathname = document.location.pathname;
});

export default router;
